import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
export var useCountDown = function useCountDown() {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    seconds = _useState2[0],
    setSeconds = _useState2[1];
  useEffect(function () {
    var timerId = setTimeout(function () {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return function () {
      return clearTimeout(timerId);
    };
  }, [seconds]);
  var start = useCallback(function (from) {
    setSeconds(from);
  }, []);
  return {
    seconds: seconds,
    start: start
  };
};